<template>
  <profile-section
    section-title="Activation Code"
  >
    <profile-subsection
      action-text="Enter Activation Code"
      :editing="activeSection === 'Activation'"
      :disabled="activeSection && activeSection !== 'Activation'"
      active-btn-text="Activate"
      @inactive-action="$emit('set-active', 'Activation')"
      @cancel-action="$emit('clear-active')"
      @active-action="activate"
    >
      <template #active>
        <activation :activators="activators" />
      </template>
    </profile-subsection>
  </profile-section>
</template>

<script>
import Activation from '@components/activation/show';
import ProfileSection from '@components/profile/section';
import ProfileSubsection from '@components/profile/subsection';

import ActivationMixin from '@/mixins/activation';

const ACTIVATION_EVENT = 'activation-code-change';

export default {
  components: { Activation, ProfileSection, ProfileSubsection },
  mixins: [ActivationMixin],
  props: {
    activeSection: {
      type: String,
    },
  },
  emits: ['set-active', 'clear-active'],
  data() {
    return {
      activationCodes: {},
    };
  },
  computed: {
    activators() {
      return this.$store.getters['activation/activators'].filter(a => a.activatorType !== 'Ase');
    },
  },
  created() {
    this.$eventBus.$on(ACTIVATION_EVENT, this.updateActivationCodes);
  },
  beforeUnmount() {
    this.$eventBus.$off(ACTIVATION_EVENT);
  },
  methods: {
    activate() {
      const params = {
        activationCodes: this.activationCodes,
      };

      this.$store.dispatch('activation/activateUser', params).then(results => {
        this.activationCodeNotifications(results);
      });
    },
  },
};
</script>

<style lang='scss' scoped>
  :deep(label.title) {
    display: none;
  }
</style>
